import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Buttons/Button';
import { TYPES } from './DialogTypes';

function DialogActions({
  literals, type, actions, onClick,
}) {
  if (!Object.values(TYPES).includes(type)) return null;

  const buttonConfig = {
    [TYPES.CUSTOM]: actions?.map((action, i) => ({
      key: `custom-${i}`,
      props: { className: 'btn-sm', ...action, onClick: () => onClick(action.onClick()) },
    })),
    [TYPES.ALERT]: [{
      color: 'primary',
      text: literals.accept,
      onClick: () => onClick(true),
    }],
    [TYPES.SUCCESS]: [{
      color: 'success',
      text: literals.accept,
      onClick: () => onClick(true),
    }],
    [TYPES.ERROR]: [{
      text: literals.accept,
      mode: 'danger',
      onClick: () => onClick(true),
    }],
    [TYPES.LOADING]: [],
    default: [
      {
        key: 'confirm',
        color: type === TYPES.CONFIRM_DANGER ? 'danger' : 'primary',
        text: literals.confirm,
        onClick: () => onClick(true),
      },
      {
        key: 'cancel',
        color: 'transparent',
        text: literals.cancel,
        onClick: () => onClick(false),
      },
    ],
  };

  return (buttonConfig[type] || buttonConfig.default).map(btn => (
    <Button
      key={btn.key}
      className='btn-sm'
      color={btn.color}
      text={btn.text}
      onClick={btn.onClick}
    />
  ));
}

DialogActions.propTypes = {
  literals: PropTypes.shape({
    accept: PropTypes.string.isRequired,
    confirm: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
  actions: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DialogActions;
